import { Button, Modal } from 'react-daisyui';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { tInactiveConversationModal } from './InactiveConversationModal.types';

/**
 * Modal component that warns the user about sending templates to an inactive conversation.
 * Displays a warning icon and message about Meta's policy on sending templates without response.
 */
export default function InactiveConversationModal(
  props: tInactiveConversationModal,
): JSX.Element {
  const { isOpen, onClose, onConfirm } = props;

  return (
    <Modal open={isOpen} backdrop={true} responsive={true}>
      <Modal.Body className="flex flex-col items-center text-center p-6">
        <ExclamationTriangleIcon className="w-24 h-24 text-yellow-400 mb-4" />
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Advertencia: Esta conversación está inactiva.
        </h2>
        <p className="text-gray-600 mb-6">
          Meta puede bloquear tu cuenta si envías más de 2 plantillas sin
          respuesta.
          <br />
          ¿Deseas continuar con el envío de la plantilla?
        </p>
        <div className="flex gap-8 w-full justify-center">
          <Button
            className="btn-primary min-w-32"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            className="btn-primary min-w-32"
            onClick={onConfirm}
          >
            Enviar
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
